/** When the user wants to create an in-editor link to another section of their content,
 *  these objects render the previews shown in the dropdown for our images and galleries.
 *  See also: https://ricos.js.org/docs/plugins_api/LinkPlugin
 * */
import React from 'react';
import i18next from 'i18next';
import EditorDumbo from '../../DeviationViews/Dumbo';
import shortenNumber from '@wix/da-ds/pkg/utils/shortenNumber';
var PREVIEW_IMAGE_WIDTH = 50;
// slightly shorter - without this upper and lower borders in plugin don't work
var PREVIEW_IMAGE_HEIGHT = 48;
export var getAnchorBlockPreview = function (_a) {
    var type = _a.type, data = _a.data;
    switch (type) {
        case 'wix-draft-plugin-image':
            return getImageAnchorBlockPreview(data);
        case 'wix-draft-plugin-gallery':
            return getGalleryAnchorBlockPreview(data);
        default:
            // This allows the block previews built into the plugin to be used for other types
            return undefined;
    }
};
/** Returns a thumbnail and data for a single deviation */
export var getImageAnchorBlockPreview = function (data) {
    var deviation = data.data;
    return deviation
        ? {
            thumbnail: (React.createElement(EditorDumbo, { deviation: deviation, width: PREVIEW_IMAGE_WIDTH, height: PREVIEW_IMAGE_HEIGHT })),
            type: i18next.t('common.deviation'),
            content: deviation.title,
        }
        : undefined;
};
/** Chooses the first image of the gallery and provides a count of deviations */
export var getGalleryAnchorBlockPreview = function (data) {
    var deviations = data.data;
    var deviationCount = deviations === null || deviations === void 0 ? void 0 : deviations.length;
    return deviationCount
        ? {
            thumbnail: (React.createElement(EditorDumbo, { deviation: deviations[0], width: PREVIEW_IMAGE_WIDTH, height: PREVIEW_IMAGE_HEIGHT })),
            type: i18next.t('common.gallery'),
            content: i18next.t('common.deviationCount', {
                formattedCount: shortenNumber(deviationCount),
                count: deviationCount,
            }),
        }
        : undefined;
};
//# sourceMappingURL=AnchorBlockPreview.js.map